import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

const queryEnter = query(
  ':enter',
  [
    style({ opacity: 0, transform: 'translateX(-100%) scale(0)' }),
    stagger(50, [animate('500ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'none' }))]),
  ],
  {
    optional: true,
  },
);

export const slideInAnimation = trigger('slideIn', [
  transition('false => true', [queryEnter]),
  transition('void => *', [queryEnter]),
]);
